enum OrderStatusEnum {
  FUNDING_CONFIRMED = 'Funding Confirmed',
  CANCELLED = 'Cancelled',
  DENIED = 'Denied',
  PENDING = 'Pending',
}

export default OrderStatusEnum;
